/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';

// Constants
const STRENGTHS = [
    'very_weak',
    'weak',
    'good',
    'strong',
    'good_job'
];

const __vue_script__ = {
    name: 'ProfilePassword',

    components: { BaseInput },

    props: {
        errors: {
            type: [String, Object, Array],
            default: () => ([])
        },

        value: {
            type: String,
            default: ''
        },

        name: {
            type: String,
            default: 'password'
        }
    },

    data() {
        return {
            password: this.value,
            passwordSuggestion: '',
            strength: '',
            submitting: false,
            zxcvbn: null,
            loading: true
        };
    },

    computed: {
        /** @returns {string} the CSS class of the password field */
        strengthClass() {
            return this.strength ? this.strength.replace('_', '-') : '';
        },

        /** @returns {string} the password tooltip text */
        passwordTip() {
            return (!this.password || !this.password.length) ? this.$i18n.t('login.forms.tips.new_password').toString() : '';
        }
    },

    async created() {
        this.zxcvbn = await System.import(`${window.BSTG.extLibs}/zxcvbn.js`);
        this.loading = false;
    },

    methods: {
        /**
         * Performs the password quality check
         *
         * @param {Event} event the input event
         */
        analyzePassword(event) {
            if (!this.password || !this.password.length) {
                this.passwordSuggestion = '';
                return;
            }

            const { score, feedback } = this.zxcvbn(this.password);
            const passwdTooShort = this.password.length < this.$const.MIN_PASSWORD_LENGTH;
            const suggestion = passwdTooShort ? this.$const.MIN_PASSWORD_LENGTH : feedback.suggestions[0];

            this.strength = passwdTooShort ? 'too_short' : STRENGTHS[score];
            this.passwordSuggestion = this.$i18n.t(`login.forms.strength.${this.strength}`, [suggestion]).toString();

            this.$emit('input', event);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-input',{staticClass:"new-password",class:_vm.strengthClass,attrs:{"placeholder":_vm.$t('login.forms.new_password'),"type":"password","name":_vm.name,"errors":_vm.errors,"autocomplete":"new-password","hint":_vm.passwordSuggestion,"tip":_vm.passwordTip},on:{"input":_vm.analyzePassword},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ProfilePassword.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__